
    import CompletedProjects from './CompletedProjects.vue';

    export default {
        name: 'CompletedSection',
        components: {
            CompletedProjects,
        },
        props: {
            pageContents: {
                type: Array,
                default: () => [],
            },
        },
    };
